import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { extender } from "../../backend/class-extender";
import { User } from "../user";
import { GoldenNotificationEntityConfig } from "./config";
import { GoldenNotificationFilters } from "./filters";
import { GoldenNotificationMethods } from "./methods";

@HyperEntity("golden-notification", GoldenNotificationEntityConfig)
export class GoldenNotification extends extender(
  GoldenNotificationFilters,
  GoldenNotificationMethods,
) {
  @Fields.id()
  id = "";

  @Fields.date({
    dbName: "time_sent",
  })
  timeSent?: Date;

  @Fields.boolean()
  sent = false;

  @Fields.string({
    dbName: "user_id",
  })
  userId = "";

  @Relations.toOne<GoldenNotification, User>(() => User, "userId")
  user?: User;

  @Fields.createdAt({
    dbName: "created_at",
  })
  createdAt: Date = new Date();

  @Fields.updatedAt({
    dbName: "updated_at",
  })
  updatedAt: Date = new Date();
}
